export default __webpack_public_path__ + "static/media/listings.d92973a0.svg";